module.exports = __webpack_public_path__ + "static/media/coinbaseWalletIcon.aa4c7a76.svg";